import { render, staticRenderFns } from "./OrmBatchStatistics.vue?vue&type=template&id=6acfc7d0"
import script from "./OrmBatchStatistics.vue?vue&type=script&lang=js"
export * from "./OrmBatchStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports